import { useQueryClient, UseMutationResult } from "@tanstack/react-query";
import { showSuccessNotification, showWarningNotification } from "@/components/common/utils/notify";
import { FileMetaDataDto } from "@/shared/api/model";
import { useUpdateFileInfo as useUpdateFileInfoOrval } from "@/shared/api/client/file-upload";

export const useUpdateFileUpload = () => {
    const queryClient = useQueryClient();
    
    // Use Orval-generated hook with options
    const mutation = useUpdateFileInfoOrval({
        mutation: {
            onSuccess: () => {
                showSuccessNotification("Success", "File information updated successfully");
                queryClient.invalidateQueries({queryKey: ["fileList"]}).then(() => console.log("done"));
            },
            onError: (error: any) => {
                showWarningNotification("Error", error.message);
            },
        }
    });

    // Adapt Orval mutation to match original interface
    return {
        ...mutation,
        mutateAsync: async (fileData: FileMetaDataDto) => {
            const response = await mutation.mutateAsync({ data: fileData });
            return response;
        },
        mutate: (fileData: FileMetaDataDto, options: any) => {
            mutation.mutate({ data: fileData }, options);
        },
        data: mutation.data
    } as UseMutationResult<FileMetaDataDto, Error, FileMetaDataDto>;
};
